import React from 'react';
import ReactDOM from 'react-dom';
import { Button, Modal } from '@kajabi/sage-react';

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
  active?: boolean;
};

const RestartConfirmatioNModal = ({ onConfirm, onCancel, active = false }: Props) =>
  ReactDOM.createPortal(
    <Modal active={active} onExit={onCancel}>
      <Modal.Header title="Restart AMA?" />
      <Modal.Body>
        Are you sure you want to restart the chat? Your chat history will be forgotten from all open
        instances of Ama.
      </Modal.Body>
      <Modal.Footer>
        <Button color={Button.COLORS.SECONDARY} onClick={onCancel}>
          Nevermind
        </Button>
        <Button onClick={onConfirm}>Restart</Button>
      </Modal.Footer>
    </Modal>,
    document.body,
  );

export default RestartConfirmatioNModal;
